import { memo } from 'react';
import clsx from 'clsx';
import { ComponentMemo } from '@headless-workspace/typings';
import { GlowSkeleton } from '../../atoms';
import { ProductTileContentSkeleton, ProductTileImgSkeleton } from './ProductTileSkeleton';

export const GlowProductTileSkeleton: ComponentMemo = memo(() => {
    return (
        <div
            className={clsx(
                'flex flex-col gap-0.5',
                'h-full w-productTileMobile tablet:w-productTile',
                'p-0.5 tablet:p-1',
                'border-medium border-solid rounded-0.5 border-border-primary',
                'bg-surface-primary',
            )}
            aria-hidden={true}
        >
            <GlowSkeleton width={'4rem'} height={'1.5rem'} />
            <ProductTileImgSkeleton />
            <div className={'flex flex-col gap-0.25'}>
                <ProductTileContentSkeleton />
            </div>

            <GlowSkeleton width={'6rem'} height={'1.5rem'} />

            <div className={'flex flex-col gap-0.25'}>
                <GlowSkeleton width={'6.938rem'} height={'0.938rem'} />
                <GlowSkeleton width={'6.938rem'} height={'0.938rem'} />
            </div>

            <GlowSkeleton containerClassName={'w-full'} height={'3rem'} />
        </div>
    );
});

GlowProductTileSkeleton.displayName = 'GlowProductTileSkeleton';
